import { useEffect, useState } from "react";
import api from "@/lib/api";

const PREVIEW_KEY = "pl_layout_preview";
const vis = (ids) => ids.map((id) => ({ id, visible: true }));
export const DEFAULT_LAYOUT = {
  home: { split: "1/2", mobile_order: "main_first", left: vis(["image", "howto", "steps", "tasks"]), main: vis(["title", "register", "ticket", "classroom"]), inside: vis(["schedule", "timer"]), page: vis(["announcement", "programs", "feedback", "testimonials"]) },
  classroom: { blocks: vis(["welcome", "today_banner", "dayline", "ticker", "live_note", "day_strip", "content", "tasks_board", "countdown", "footer"]) },
};
export const LEFT_W = { "1/3": "sm:w-1/3", "2/5": "sm:w-2/5", "1/2": "sm:w-1/2", "3/5": "sm:w-3/5" };

export const previewToken = () => {
  if (typeof window === "undefined") return "";
  const q = new URLSearchParams(window.location.search).get("lp");
  if (q) sessionStorage.setItem(PREVIEW_KEY, q);
  return sessionStorage.getItem(PREVIEW_KEY) || "";
};
export const exitPreview = () => { sessionStorage.removeItem(PREVIEW_KEY); const u = new URL(window.location.href); u.searchParams.delete("lp"); window.location.href = u.toString(); };

let cache = null;
const fetchLayout = () => {
  if (cache) return cache;
  const tok = previewToken();
  cache = api.get("/layout", { params: tok ? { preview: tok } : {} })
    .then(({ data }) => ({ layout: data.layout, preview: !!data.preview }))
    .catch(async (err) => {
      if (tok && err?.response?.status === 404) {
        sessionStorage.removeItem(PREVIEW_KEY);
        // fetch the published layout directly — do not re-read ?lp from the URL (that caused an endless 404 loop)
        return api.get("/layout").then(({ data }) => ({ layout: data.layout, preview: false })).catch(() => ({ layout: DEFAULT_LAYOUT, preview: false }));
      }
      return { layout: DEFAULT_LAYOUT, preview: false };
    });
  return cache;
};

export const useLayout = () => {
  const [state, setState] = useState({ layout: DEFAULT_LAYOUT, preview: false, ready: false });
  useEffect(() => { let on = true; fetchLayout().then((r) => on && setState({ ...r, ready: true })); return () => { on = false; }; }, []);
  return state;
};
